app.controller('SupportMarketingAssetController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const landscapeCategorySlugs =
        [
            'kitchens',
            'bedrooms',
            'social-media-assets'
        ];

    $scope.isLandscapePerspectivePreferred = function (post) {
        for (let i = 0; i < post.category_list.length; i++) {
            if (landscapeCategorySlugs.includes(post.category_list[i].slug)) {
                return true;
            }
        }
        return false;
    }

    $scope.preferredImage = function (post) {
        if (!post.media_details || !post.media_details.sizes) {
            return null;
        }
        return !$scope.isLandscapePerspectivePreferred(post) ? post.media_details.sizes['medium-portrait'] : post.media_details.sizes['medium-landscape'];
    }
}]);